<script>
	import { onMount } from "svelte";
	import { Col, Row } from "sveltestrap";
	import queryString from "query-string";

	import client from "../../../services/client";
	import {
		totalPages,
		loading,
		carData,
		trigerBlackoutSearch,
	} from "../../../store/store";
	import CarManagementTable from "./CarManagementTable.svelte";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import FilterForm from "../../../components/FilterForm/FilterForm.svelte";

	let data = [];

	//Start Logic for filter feature
	const query = queryString.parse(window.location.search);
	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	});
	let queryParams = `?page=1&size=100`;
	let searchParams = window.location.search.toString();
	let querySize = searchParams.includes("size");
	let queryPage = searchParams.includes("page");
	let queryStatus = searchParams.includes("carStatus");
	let queryPlateNumber = searchParams.includes("plateNumber");
	let queryStartDateRange = searchParams.includes("startDateRange");
	let queryEndDateRange = searchParams.includes("endDateRange");
	let queryCarmake = searchParams.includes("carMake");
	let queryCarpark = searchParams.includes("carpark");
	let PriceGroupId = searchParams.includes("PriceGroupId");

	if (queryPage) {
		queryParams = `?page=${params.page}&size=100`;
	}
	if (queryStatus) {
		queryParams = queryParams.concat(`&status=${params.carStatus}`);
	}
	if (queryPlateNumber) {
		queryParams = queryParams.concat(`&Keyword=${params.plateNumber}`);
	}
	if (queryStartDateRange) {
		queryParams = queryParams.concat(`&startDate=${params.startDateRange}`);
	}
	if (queryEndDateRange) {
		queryParams = queryParams.concat(`&endDate=${params.endDateRange}`);
	}
	if (queryCarmake) {
		queryParams = queryParams.concat(`&makeId=${params.carMake}`);
	}
	if (queryCarpark) {
		queryParams = queryParams.concat(`&CarParkId=${params.carpark}`);
	}
	if (PriceGroupId) {
		queryParams = queryParams.concat(
			`&PriceGroupId=${params.PriceGroupId}`
		);
	}
	//End Logic for filter feature

	// FETCH Vehicle LIST
	onMount(async () => {
		try {
			loading.set(true);
			const res = await client(`/v1/filter${queryParams}`, {
				method: "GET",
				version: "Vehicle",
			});
			data = res.data.dataList;
			carData.set(data);
			data.totalCount = res.data.totalCount;
			totalPages.set(res.data.totalPage);
			if (res.data.dataList) {
				loading.set(false);
			}
		} catch (err) {
			loading.set(false);
			console.log(err.response);
			// errorMessage.set(err.response.data.errors[""]["0"]);
		}
	});

	async function fetchData() {
		//Start Logic for filter feature
		const query = queryString.parse(window.location.search);
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		});
		let queryParams = `?page=1&size=100`;
		let searchParams = window.location.search.toString();
		let querySize = searchParams.includes("size");
		let queryPage = searchParams.includes("page");
		let queryStatus = searchParams.includes("carStatus");
		let queryPlateNumber = searchParams.includes("plateNumber");
		let queryStartDateRange = searchParams.includes("startDateRange");
		let queryEndDateRange = searchParams.includes("endDateRange");
		let queryCarmake = searchParams.includes("carMake");
		let queryCarpark = searchParams.includes("carpark");
		let PriceGroupId = searchParams.includes("PriceGroupId");

		if (queryPage) {
			queryParams = `?page=${params.page}&size=100`;
		}
		if (queryStatus) {
			queryParams = queryParams.concat(`&status=${params.carStatus}`);
		}
		if (queryPlateNumber) {
			queryParams = queryParams.concat(`&Keyword=${params.plateNumber}`);
		}
		if (queryStartDateRange) {
			queryParams = queryParams.concat(
				`&startDate=${params.startDateRange}`
			);
		}
		if (queryEndDateRange) {
			queryParams = queryParams.concat(`&endDate=${params.endDateRange}`);
		}
		if (queryCarmake) {
			queryParams = queryParams.concat(`&makeId=${params.carMake}`);
		}
		if (queryCarpark) {
			queryParams = queryParams.concat(`&CarParkId=${params.carpark}`);
		}
		if (PriceGroupId) {
			queryParams = queryParams.concat(
				`&PriceGroupId=${params.PriceGroupId}`
			);
		}
		//End Logic for filter feature
		try {
			loading.set(true);
			const res = await client(`/v1/filter${queryParams}`, {
				method: "GET",
				version: "Vehicle",
			});
			data = res.data.dataList;
			carData.set(data);
			data.totalCount = res.data.totalCount;
			totalPages.set(res.data.totalPage);
			if (res.data.dataList) {
				loading.set(false);
			}
		} catch (err) {
			loading.set(false);
			console.log(err.response);
			// errorMessage.set(err.response.data.errors[""]["0"]);
		}
	}

	$: if ($trigerBlackoutSearch) {
		fetchData();
	}
</script>

<Row>
	<Col xs={12}>
		<div>
			<!-- <ErrorMessageHandler message={err} /> -->
			<Col className="row d-flex align-items-start mx-0">
				<PageHeader title="Select Car For Blackout" />
			</Col>
			<div class="d-flex flex-row">
				<Col xs={6}>
					<FilterForm
						priceGroup
						plateNumber
						carStatus
						carMake
						carpark
						startDateRange
						endDateRange
						blackoutSearch
					/>
				</Col>
			</div>
			<div />
		</div>
	</Col>
	<Col class="my-2">
		<CarManagementTable {data} />
	</Col>
</Row>
